import { ReactNode,useEffect } from 'react';

import { PreviewBarLayout } from '~/components/organisms/previewBar/PreviewBarLayout';
import { PREVIEW_BAR_VIEW_TYPE } from '~/constants/common';
import { PATH } from '~/constants/route-path';
import { useAppDispatch } from '~/hooks/useRedux';
import NavigationBottom from '~/pages/CreateQR/components/NavigationBottom';
import Stepper from '~/pages/CreateQR/components/Stepper';
import { googleDataLayerPush } from '~/services/google-analytics-service';
import { stepperSlice } from '~/store/reducers/stepepr';
import useBuilderStore from '~/store/useBuilderStore';
import { PreviewBarViewType } from '~/types/builder';
import { StaticQrCodeData } from '~/types/qrCode';

import { StyledContainer, StyledContent } from './styled';

const { actions } = stepperSlice;

interface StaticContentComponentProps {
  handleStep: (step: number) => void;
  isNextProcessing?: boolean;
  qrCode?: StaticQrCodeData;
  mockup: ReactNode;
  form: ReactNode;
  isQrLoading?: boolean;
  defaultView?: PreviewBarViewType;
  isDisabledQrCodePreview?: boolean;
}

export const StaticContentComponent = ({
  handleStep,
  isNextProcessing,
  qrCode,
  mockup,
  form,
  isQrLoading,
  defaultView = PREVIEW_BAR_VIEW_TYPE.PHONE,
  isDisabledQrCodePreview = false,
}: StaticContentComponentProps) => {
  const dispatch = useAppDispatch();
  const { setPreviewViewType, activeStep } = useBuilderStore();

  useEffect(() => {
    setPreviewViewType(defaultView);
  }, [defaultView]);

  const handleBack = () => {
    if (activeStep === 1) {
      dispatch(actions.setRedirectRoute(PATH.QR.CREATE));
    } else {
      handleStep(activeStep - 1);
    }
  };

  const _handleStep = (value: number) => {
    handleStep(value);
    if (value === 3) {
      window.dataLayer?.push({
        event: 'create_qr_code_completed',
        qr_code_id: qrCode?.id,
        qr_code_type: qrCode?.content.type,
      });
    }
  };

  return (
    <StyledContainer>
      <Stepper handleStep={handleStep} />

      <StyledContent>
        {form}
        <PreviewBarLayout
          isQrExist={!!qrCode}
          qrCodeData={qrCode}
          isQrLoading={isQrLoading}
          isDisabledQrCodePreview={isDisabledQrCodePreview}
        >
          {mockup}
        </PreviewBarLayout>
      </StyledContent>
      <NavigationBottom isNextProcessing={isNextProcessing} handleStep={_handleStep} handleBack={handleBack} />
    </StyledContainer>
  );
};
